import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import {
  QueriesTemplateHdrModel,
  RequestBodySql
} from '../../../../../../models/aggregates/erp/dynamic-report/dynamic-report-queries-template-hdr.model';
import {ApiVisa, SqlApiResponse} from '../../shared';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueriesTemplateHdrService extends BaseApiTemplateService<QueriesTemplateHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/query-template-hdrs/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-template-hdrs/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-template-hdrs/backoffice-ep';
    this.httpClient = theHttp;
  }

  executeSql(sql: RequestBodySql, visa: ApiVisa): Observable<SqlApiResponse<any>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-template-hdrs/execute-query/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-template-hdrs/execute-query/backoffice-ep';
    }

    return this.httpClient.post<SqlApiResponse<any>>(url, sql, this.getHttpHeader(visa));
  }
}
